<template>
  <div class="carousel" v-loading="loading">
    <div class="s_wrapper">
      <el-select class="s_input" v-model="categoryId" placeholder="请选择活动分类" clearable @change="onSearch">
        <el-option v-for="item in categoryIdsArr" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select class="s_input" v-model="activityType" placeholder="请选择活动类型" clearable @change="onSearch">
        <el-option v-for="item in activityTypeArr" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select class="s_input" v-model="status" placeholder="请选择活动状态" clearable @change="onSearch">
        <el-option v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input class="s_input" v-model="activityName" placeholder="请输入活动名称" suffix-icon="el-icon-search"
        @change="onSearch" clearable></el-input>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="图片" min-width="80">
          <template slot-scope="scope">
            <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
            <div style="color: #069BBC;cursor: pointer;" @click="handleCarouselUrl(scope.row.activityPicture)">查看图片
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="activityType" label="活动类型" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.activityType == 0">投票活动</div>
            <div v-if="scope.row.activityType == 1">进群活动</div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="活动分类" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="voteCount" label="投票次数" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.voteCount">
              <span v-if="scope.row.voteType == 0">总共</span>
              <span v-if="scope.row.voteType == 1">每天</span>
              {{ scope.row.voteCount }} 次
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="singUpCount" label="已报名人数" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="signUpStartTime" label="报名开始时间" min-width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="signUpEndTime" label="报名截止时间" min-width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="voteStartTime" label="投票开始时间" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.voteStartTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="voteEndTime" label="投票截止时间" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.voteEndTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="活动状态" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" style="color: red;">未开始</div>
            <div v-if="scope.row.status == 1">报名中</div>
            <div v-if="scope.row.status == 2">报名截止</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" min-width="240" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleCommand(scope.row)">报名详情</el-button>
            <!-- <el-button class="btn" type="primary" plain @click="handleEdit(scope.row)"
              v-if="scope.row.status == 0">编辑</el-button> -->
            <el-button class="btn" type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      activityName: "",//活动名称
      tableData: [],//数据
      srcList: null, //大图预览
      status: '', //活动状态
      statusArr: [
        {
          value: '0',
          label: '未开始'
        }, {
          value: '1',
          label: '报名中'
        }, {
          value: '2',
          label: '报名截止'
        },
      ],
      activityType: '', //活动类型
      activityTypeArr: [
        {
          value: '0',
          label: '投票活动'
        }, {
          value: '1',
          label: '进群活动'
        },
      ],
      categoryId: '', //活动分类
      categoryIdsArr: [],//活动分类数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()
    this.getRequestActivityClassList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .post(this.$api.activityList, {
          activityName: this.activityName || null,
          categoryId: this.categoryId || null,
          status: this.status || null,//活动状态：0未开始；1报名中；2报名截止；
          page: this.currentPage,
          pageSize: this.pageSize,

        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 活动分类下拉框
    getRequestActivityClassList() {
      this.loading = true
      this.$axios
        .get(this.$api.activityListActivityClass)
        .then(res => {
          if (res.code == 100) {
            this.categoryIdsArr = res.result.map((item) => {
              return {
                value: item.id,
                label: item.categoryName
              }
            })
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteActivity, { params: { id: row.id } })
            .then(res => {
              if (res.code == 100) {
                this.$message.success("删除成功")
                this.onSearch()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => { })
    },
    // 新增活动
    handleAdd() {
      this.$router.push({ name: 'addEditActivity', })
    },
    // 修改活动
    handleEdit(row) {
      this.$router.push({ name: 'addEditActivity', query: { id: row.id, activityType: row.activityType } })
    },
    //查看报名详情
    handleCommand(row) {
      this.$router.push({ name: 'activityRegisterList', query: { id: row.id, activityName: row.activityName, activityType: row.activityType } })
    },
    // 查看图片
    handleCarouselUrl(imageUrl) {
      this.srcList = null
      if (imageUrl) {
        this.srcList = [imageUrl];
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传活动图片!");
      }
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },

    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.carousel {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 95px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
